import { Component, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
})
export class SubscriptionComponent implements OnDestroy {
    protected completeAll$: Subject<void> = new Subject<void>();

    public ngOnDestroy(): void {
        this.completeAll$.next();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getLatestValueFromSubscription(obj: Observable<any>): any {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let value: any;
        obj.pipe(takeUntil(this.completeAll$)).subscribe((v) => (value = v));
        return value;
    }
}
